import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './i18n';          // <-- сначала инициализация i18n
import './index.css';
import WrappedApp from './App';  // <-- потом компоненты

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <WrappedApp />
    </HelmetProvider>
  </React.StrictMode>
);